/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ArrowCurveUpRight({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9.576 2.576a.6.6 0 0 1 .848 0l3 3a.6.6 0 0 1 0 .848l-3 3a.6.6 0 0 1-.848-.848L11.552 6.6H6A2.4 2.4 0 0 0 3.6 9v4a.6.6 0 1 1-1.2 0V9A3.6 3.6 0 0 1 6 5.4h5.552L9.576 3.424a.6.6 0 0 1 0-.848Z" clipRule="evenodd" /></svg>;
}
;